import {
    Box,
    VStack,
    Text,
    Button,
    HStack,
    Separator,
    Image,
    Drawer,
    IconButton,
} from "@chakra-ui/react";

import {
    useNavigate,
    useLocation,
} from "react-router-dom";
import { useDispatch } from "react-redux";

import {
    useState,
} from "react";

import routes from "../routes";

import {
    LayoutDashboard,
    Users,
    History,
    CircleHelp,
    LogOut,
    SettingsIcon,
    ChartBarIcon,
    Phone,
    Mail,
    Globe,
    Menu,
    Bell,
    X
} from "lucide-react";
import Logo from "../assets/logo.png";
import { logoutAction } from "../state/actions/authActions";

const Sidebar = () => {
    const dispatch = useDispatch();
    const navigate =
        useNavigate();

    const location =
        useLocation();


    const [open, setOpen] =
        useState(false);

    const isActive = (
        path
    ) =>
        location.pathname === path;

    const handleLogout = () => {
        dispatch(logoutAction());

        navigate(
            routes.login,
            {
                replace: true,
            }
        );
    };

      const menuItems = [
        {
            label: "Dashboard",
            icon: LayoutDashboard,
            path: routes.dashboard,
        },
        {
            label: "My Recruits",
            icon: Users,
            path: routes.recruits,
        },
        {
            label: "Commission History",
            icon: History,
            path: routes.commissions,
        },
           {
            label: "Notifications",
            icon: Bell,
            path: routes.notifications,
        },
        {
            label: "Settings",
            icon: SettingsIcon,
            path: routes.settings,
        },
        {
            label: "Analytics",
            icon: ChartBarIcon,
            path: routes.analytics,
        },
    ];

    const SidebarContent =
        () => (
            <>
                <HStack
                    w="100%"
                    justify="space-between"
                    align="center"
                    mb={1}
                >
                    <HStack flex="1">
                        <Image
                            src={Logo}
                            h="32px"
                            w="32px"
                            objectFit="contain"
                        />

                        <Text
                            fontSize="16px"
                            fontWeight="700"
                            color="#2453FF"
                            whiteSpace="nowrap"
                        >
                            Mogoma Partner
                        </Text>
                    </HStack>

                    <IconButton
                        display={{
                            base: "flex",
                            md: "none",
                        }}
                        variant="ghost"
                        size="sm"
                        onClick={() => setOpen(false)}
                        aria-label="Close sidebar"
                        flexShrink={0}
                    >
                        <X size={22} />
                    </IconButton>
                </HStack>

                <Text
                    fontSize="sm"
                    color="gray.500"
                    mb={8}
                    ml="40px"
                >
                   Recruit. Earn. Grow.
                </Text>

                <VStack
                    align="stretch"
                    gap={2}
                >
                    {menuItems.map(
                        (
                            item
                        ) => {
                            const Icon =
                                item.icon;

                            return (
                                <Button
                                    key={
                                        item.label
                                    }
                                    justifyContent="flex-start"
                                    h="52px"
                                    borderRadius="10px"
                                    fontWeight="400"
                                    onClick={() => {
                                        navigate(
                                            item.path
                                        );

                                        setOpen(
                                            false
                                        );
                                    }}
                                    bg={
                                        isActive(
                                            item.path
                                        )
                                            ? "#2453FF"
                                            : "transparent"
                                    }
                                    color={
                                        isActive(
                                            item.path
                                        )
                                            ? "white"
                                            : "#4B5563"
                                    }
                                >
                                    <Icon
                                        size={
                                            18
                                        }
                                    />

                                    <Text ml={3}>
                                        {
                                            item.label
                                        }
                                    </Text>
                                </Button>
                            );
                        }
                    )}
                </VStack>

                <Separator
                    my={5}
                />

                <VStack
                    align="stretch"
                    gap={2}
                >
               
                    
                    <Button
                        variant="ghost"
                        justifyContent="flex-start"
                        h="52px"
                        onClick={() =>
                            navigate(
                                "/support"
                            )
                        }
                    >
                        <CircleHelp
                            size={
                                18
                            }
                        />

                        <Text ml={3}  fontWeight="400">
                            Support
                        </Text>
                    </Button>
                    
                      <Box
                        p={4}
                        borderRadius="14px"
                        bg="white"
                        border="1px solid"
                        borderColor="gray.200"
                        mb={20}
                    >
                        <Text
                            fontSize="11px"
                            fontWeight="700"
                            color="gray.500"
                            letterSpacing="1px"
                            textTransform="uppercase"
                            mb={3}
                        >
                            Contact Support
                        </Text>

                        <VStack
                            align="start"
                            gap={3}
                        >
                            <HStack
                                color="gray.600"
                                fontSize="sm"
                            >
                                <Phone
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text>
                                    +267 7601 9336
                                </Text>
                            </HStack>

                            <HStack
                                color="gray.600"
                                fontSize="sm"
                            >
                                <Mail
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text>
                                    mogoma@aigenix.co.bw
                                </Text>
                            </HStack>

                            <HStack
                                color="gray.600"
                                fontSize="sm"
                                align="start"
                            >
                                <Globe
                                    size={14}
                                    color="#2453FF"
                                />

                                <Text
                                    wordBreak="break-word"
                                >
                                    aigenix.co.bw/mogoma
                                </Text>
                            </HStack>
                        </VStack>
                    </Box>
                   
                </VStack>
                  <Box 
                    mt="auto"
                    position="sticky"
                    bottom="0"
                    borderRadius={"12px"}
                    bg="#F4F7FC"
                    py={{
                        base: 1,
                        md: 2,
                    }}
                    px={{
                        base: 3,
                        md: 0,
                    }}
                    >
                    <Button
                        variant="ghost"
                        justifyContent="center" 
                        h="40px"
                        color="red.500"
                        w="100%"
                        onClick={
                            handleLogout
                        }
                    >
                        <LogOut size={18} />

                        <Text
                            ml={3}
                            fontWeight="600"
                            fontSize={"16px"}
                        >
                            Logout
                        </Text>
                    </Button>
                </Box>
                {/* <Box mt="auto">
                    <HStack
                        p={4}
                        borderRadius="12px"
                        cursor="pointer"
                        onClick={() =>
                            navigate(
                                routes.settings
                            )
                        }
                        bg={
                            isActive(
                                routes.settings
                            )
                                ? "#2453FF"
                                : "#E8F0FF"
                        }
                    >
                        <Box
                            w="42px"
                            h="42px"
                            borderRadius="full"
                            bg="#2453FF"
                            color="white"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            fontWeight="700"
                        >
                            PW
                        </Box>

                        <Box>
                            <Text
                                fontWeight="600"
                                fontSize="12px"
                            >
                                Partner
                                Workspace
                            </Text>

                            <Text
                                fontSize="xs"
                                color="gray.500"
                            >
                                Standard
                                Tier
                            </Text>
                        </Box>
                    </HStack>
                </Box> */}
            </>
        );

    return (
        <>
            {/* Mobile Header */}

            <Box
    display={{
        base: "flex",
        md: "none",
    }}
    alignItems="center"
    px={4}
    py={3}
    bg="white"
    borderBottom="1px solid"
    borderColor="gray.200"
>
    <IconButton
        variant="ghost"
        mr={3}
        ml={-2}
        cursor="pointer"
                color="gray.600"
                _hover={{
                    color: "#2453FF",
                }}
        onClick={() =>
            setOpen(true)
        }
    >
        <Menu size={25} />
    </IconButton>

    <HStack>
        <Image
            src={Logo}
            h="30px"
        />

        <Text
            fontWeight="700"
            color="#2453FF"
        >
            Mogoma
        </Text>
    </HStack>
</Box>

            {/* Desktop Sidebar */}

           <Box
    display={{
        base: "none",
        md: "flex",
    }}
    bg="#F4F7FC"
    borderRight="1px solid"
    borderColor="gray.200"
    p={6}
    h="100vh"
    overflowY="auto"
    flexDirection="column"
>
    <SidebarContent />
</Box>

            {/* Mobile Drawer */}

            <Drawer.Root
                open={open}
                placement="start"
                onOpenChange={(
                    e
                ) =>
                    setOpen(
                        e.open
                    )
                }
            >
                <Drawer.Backdrop />

                <Drawer.Positioner>
                    <Drawer.Content maxW="280px"  h="100dvh">
                        <Drawer.Body p={6}>
                           <Box
                            display="flex"
                            flexDirection="column"
                            h="100vh"
                            
                        >
                    <SidebarContent />
                </Box> 
                        </Drawer.Body>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Drawer.Root>
        </>
    );
};

export default Sidebar;